import { render, staticRenderFns } from "./TwismWalletConfirmModal.vue?vue&type=template&id=70dec769&scoped=true&"
import script from "./TwismWalletConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./TwismWalletConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./TwismWalletConfirmModal.vue?vue&type=style&index=0&id=70dec769&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dec769",
  null
  
)

export default component.exports